import React from 'react';
import PropTypes from 'prop-types';
import SvgElement from '../../uiElements/svgElement/SvgElement';
import './_button.scss';

const arrowRight = '/assets/miljostatus/icons/icon-arrow-right-black.svg';

const renderClassNames = (props) => {
    let cN = `c_button c_button--${props.styleType ? props.styleType : 'dark'}`;
    if (props.disabled) {
        cN = `${cN} c_button--disabled`;
    }
    if (props.className) {
        cN = `${cN} ${props.className}`;
    }
    return cN;
};

const Button = (props) => {
    if (props.href && props.href.length > 0) {
        return (
            <a
                className={renderClassNames(props)}
                href={props.href}
            >
                {props.preIcon &&
                <SvgElement
                    src={props.preIcon}
                    title="Ikon i knapp"
                    desc="Ikon"
                    className="c_button__left-icon"
                />
                }
                <span>{props.text}</span>
                {props.showArrow &&
                <SvgElement
                    src={arrowRight}
                    title="Gå videre"
                    desc="Gå videre"
                    className="c_button__arrow"
                />
                }
            </a>
        );
    }
    return (
        <button
            className={renderClassNames(props)}
            onClick={props.onClick || null}
            type={props.type || null}
        >
            {props.preIcon &&
            <SvgElement
                src={props.preIcon}
                title="Ikon i knapp"
                desc="Ikon"
                className="c_button__left-icon"
            />
            }
            <span>{props.text}</span>
            {props.showArrow &&
            <SvgElement
                src={arrowRight}
                title="Gå videre"
                desc="Gå videre"
                className="c_button__arrow"
            />
            }
        </button>
    );
};

Button.propTypes = {
    text: PropTypes.string.isRequired,
    styleType: PropTypes.string, // eslint-disable-line
    type: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string, // eslint-disable-line
    showArrow: PropTypes.bool,
    disabled: PropTypes.bool,  // eslint-disable-line
    preIcon: PropTypes.object,
    href: PropTypes.string
};

Button.defaultProps = {
    styleType: 'dark',
    showArrow: false,
    disabled: false
};

export default Button;
